import { Card, Group, Space, Text, Stack } from "@mantine/core";
import {
  ID_CADASTROS_GRUPOS_DE_PERGUNTAS,
  ID_CADASTROS_PERGUNTAS,
  ID_CADASTROS_PROJETOS,
  ID_CADASTROS_QUESTIONARIOS,
  ID_CADASTROS_REGIOES,
  ID_CADASTROS_TIPO_DE_RESPOSTAS,
  ID_CADASTROS_EMBAIXADORES,
  ID_COLABORADORES,
  ID_COMITE_DE_INOVACAO,
  ID_CONFIGURACOES_CATEGORIA_DE_INOVACAO,
  ID_CONFIGURACOES_TIPO_DE_JOGADA,
  ID_CONFIGURACAO_FORMULARIO_IDEIAS,
  ID_CONFIGURACAO_TEMPLATES_RELATORIOS,
  ID_CONVIDAR_COLABORADORES,
  ID_DESAFIOS_INOVACAO_CATEGORIA_DE_DESAFIOS,
  ID_DESAFIOS_INOVACAO_DESAFIOS,
  ID_DESAFIOS_INOVACAO_REGULAMENTOS,
  ID_EMPRESA,
  ID_EXTRAS_ALTERAR_FASE_DA_EMPRESA,
  ID_EXTRAS_DESCONSIDERAR_AVALIACAO,
  ID_EXTRAS_IMPLEMENTACAO_DAS_JOGADAS,
  ID_EXTRAS_VISUALIZAR_NOTAS_DE_AVALIADORES,
  ID_GERENCIAR_EVIDENCIAS,
  ID_JOGADAS_DE_INOVACAO,
  ID_LISTAGEM_IDEIAS_IDEIAS,
  ID_LISTAGEM_IDEIAS_REGULAMENTOS,
  ID_QUESTIONARIO_INOVACAO,
  ID_RANKING_COLABORADORES,
  ID_RELATORIOS_DIAGNOSTICO,
  ID_RELATORIOS_VISAO_GERAL_DESAFIOS,
  ID_RELATORIOS_VISAO_GERAL_IDEIAS,
  ID_RESPONDER_QUESTIONARIO,
  ID_RESULTADO_VOTACAO,
  ID_CONFIGURACOES_PERSONALIZACAO,
  ID_TIPO_DE_INOVACAO,
  ID_TODAS_ATIVIDADES,
  ID_CONFIGURACAO_CONTAS_EMAIL,
  ID_CONFIGURACAO_EVENTOS_EMAIL,
  ID_TRIAGEM_IDEIAS_IA
} from "@/utils/constants";
import AutorizacaoItem from "../autorizacao-item";
import HeaderTable from "../header-table";

const CONFIGURACOES = "Configurações";
const GESTAO_INOVACAO = "Gestão de inovação";
const DIAGNOSTICO = "Diagnóstico";
const INCENTIVO_INOVACAO = "Incentivo a Inovação";

type TItem = {
  id: string;
  label: string;
  grupo?: string;
  editar?: boolean;
  remover?: boolean;
  criar?: boolean;
};

const ListaDeAutorizacaoDePerfil = ({ select }: { select: string | null }) => {
  const grupos: Record<string, TItem[]> = {};
  const ids = lista.map((item) => item.id);
  const hasDuplicates = ids.length !== new Set(ids).size;
  if (hasDuplicates) {
    throw new Error("A lista de autoriza es possui itens com o mesmo ID");
  }
  /* eslint-disable security/detect-object-injection*/
  for (const item of lista) {
    const nome = item.grupo ?? "Sem grupo";
    if (!grupos[nome]) grupos[nome] = [];
    grupos[nome]?.push(item);
  }

  return (
    <>
      <HeaderTable />
      {select === null ? (
        <Card radius={0}>
          <Group align="center" justify="center">
            <Text size="md">Acesso não selecionado!</Text>
          </Group>
          <Space h="md" />
        </Card>
      ) : (
        <Stack>
          {Object.entries(grupos).map(([grupoNome, items]) => (
            <Card key={grupoNome} radius={0}>
              <Text fw={500} size="lg" mb="sm">
                {grupoNome}
              </Text>
              {items.map((item) => (
                <AutorizacaoItem
                  key={item.id}
                  item={{
                    ...item,
                    editar: item.editar ?? false,
                    remover: item.remover ?? false,
                    criar: item.criar ?? false
                  }}
                  select={select}
                />
              ))}
              <Space h="md" />
            </Card>
          ))}
        </Stack>
      )}
    </>
  );
};

export default ListaDeAutorizacaoDePerfil;

// prettier-ignore
const lista: TItem[] = [
  { id: ID_TODAS_ATIVIDADES, label: "Todas Atividades", grupo: GESTAO_INOVACAO, editar: false, remover: true, criar: true },
  { id: ID_RANKING_COLABORADORES, label: "Ranking de colaboradores", grupo: GESTAO_INOVACAO, editar: false, remover: true, criar: true },
  { id: ID_COMITE_DE_INOVACAO, label: "Comitê de inovação", grupo: GESTAO_INOVACAO, editar: true, remover: true, criar: false },
  { id: ID_LISTAGEM_IDEIAS_IDEIAS, label: "Listagem de Ideias » Ideias", grupo: GESTAO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_LISTAGEM_IDEIAS_REGULAMENTOS, label: "Listagem de Ideias » Regulamentos", grupo: GESTAO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_DESAFIOS_INOVACAO_DESAFIOS, label: "Desafios de Inovação » Desafios", grupo: GESTAO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_DESAFIOS_INOVACAO_REGULAMENTOS, label: "Desafios de Inovação » Regulamentos", grupo: GESTAO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_DESAFIOS_INOVACAO_CATEGORIA_DE_DESAFIOS, label: `Desafios de Inovação » Categorias de Desafios`, grupo: GESTAO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_RELATORIOS_VISAO_GERAL_IDEIAS, label: "Relatórios » Visão Geral de Ideias", grupo: GESTAO_INOVACAO, editar: true, remover: true, criar: true },
  { id: ID_RELATORIOS_VISAO_GERAL_DESAFIOS, label: "Relatórios » Visão Geral de Desafios", grupo: GESTAO_INOVACAO, editar: true, remover: true, criar: true },

  { id: ID_QUESTIONARIO_INOVACAO, label: "Questionário de Inovação", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_RESPONDER_QUESTIONARIO, label: "Responder Questionário", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_CONVIDAR_COLABORADORES, label: "Convidar Colaboradores", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_GERENCIAR_EVIDENCIAS, label: "Gerenciar Evidências", grupo: DIAGNOSTICO, editar: false, remover: true, criar: true },
  { id: ID_RESULTADO_VOTACAO, label: "Votação Prêmio Empresa Inspiradora", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_RELATORIOS_DIAGNOSTICO, label: "Relatórios", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_CADASTROS_PROJETOS, label: "Cadastros » Projetos", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_QUESTIONARIOS, label: "Cadastros » Questionários", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_TIPO_DE_RESPOSTAS, label: "Cadastros » Tipo de Respostas", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_GRUPOS_DE_PERGUNTAS, label: "Cadastros » Grupos de Perguntas", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_PERGUNTAS, label: "Cadastros » Perguntas", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_REGIOES, label: "Cadastros » Regiões", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_CADASTROS_EMBAIXADORES, label: "Cadastros » Embaixadores", grupo: DIAGNOSTICO, editar: false, remover: false, criar: false },
  { id: ID_EXTRAS_VISUALIZAR_NOTAS_DE_AVALIADORES, label: "Extras » Visualizar notas de avaliadores", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_EXTRAS_DESCONSIDERAR_AVALIACAO, label: "Extras » Desconsiderar avaliação", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },
  { id: ID_EXTRAS_ALTERAR_FASE_DA_EMPRESA, label: "Extras » Alterar fase da Empresa", grupo: DIAGNOSTICO, editar: true, remover: true, criar: true },

  { id: ID_TIPO_DE_INOVACAO, label: "Tipo de inovação", grupo: INCENTIVO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_JOGADAS_DE_INOVACAO, label: "Jogadas de inovação", grupo: INCENTIVO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_CONFIGURACOES_CATEGORIA_DE_INOVACAO, label: "Configurações » Categorias de Inovação", grupo: INCENTIVO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_CONFIGURACOES_TIPO_DE_JOGADA, label: "Configurações » Tipo de jogada", grupo: INCENTIVO_INOVACAO, editar: false, remover: false, criar: false },
  { id: ID_EXTRAS_IMPLEMENTACAO_DAS_JOGADAS, label: "Extras » Implementação das jogadas", grupo: INCENTIVO_INOVACAO, editar: true, remover: true, criar: false },

  { id: ID_EMPRESA, label: "Empresa", grupo: CONFIGURACOES, editar: false, remover: false, criar: false },
  { id: ID_COLABORADORES, label: "Colaboradores", grupo: CONFIGURACOES, editar: false, remover: false, criar: false },
  { id: ID_CONFIGURACAO_CONTAS_EMAIL, label: "Contas de Email", grupo: CONFIGURACOES, editar: true, remover: true, criar: true },
  { id: ID_CONFIGURACAO_EVENTOS_EMAIL, label: "Eventos de Email", grupo: CONFIGURACOES, editar: true, remover: true, criar: true },
  { id: ID_TRIAGEM_IDEIAS_IA, label: "Ver aderência IA", grupo: CONFIGURACOES, editar: true, remover: true, criar: true },
  { id: ID_CONFIGURACOES_PERSONALIZACAO, label: "Personalização", grupo: CONFIGURACOES, editar: true, remover: true, criar: true },
  { id: ID_CONFIGURACAO_FORMULARIO_IDEIAS, label: "Gestão da Inovação » Configuração de Ideias", grupo: CONFIGURACOES, editar: true, remover: true, criar: true },
  { id: ID_CONFIGURACAO_TEMPLATES_RELATORIOS, label: "Diagnóstico » Templates de Relatórios", grupo: CONFIGURACOES, editar: true, remover: true, criar: true }
];
